import { Outlet } from 'react-router-dom';
import { Header } from './ui/Header';
import { ScrollVeil, FloatingParticles, CursorGlow } from './ui/depth';

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-dark-bg relative">
      <ScrollVeil />
      <FloatingParticles />
      <CursorGlow />
      <Header />
      <main className="flex-1 relative">
        <Outlet />
      </main>
    </div>
  );
}
